import React from 'react';
const contents = [{
  emoji: '📘',
  title: 'Vol. 1: Core Systems Academy',
  desc: 'Puck-moving patterns and offensive flow foundations. The bedrock of team tactics.'
}, {
  emoji: '📗',
  title: 'Vol. 2: Technical Masterclass',
  desc: "The visual biomechanics encyclopedia. Fix any player's stride or shot with 5-word cues."
}, {
  emoji: '📕',
  title: 'Vol. 3: The Session Builder',
  desc: 'Professional scaling logic. Manage any team size on the ice with zero downtime.'
}, {
  emoji: '📙',
  title: 'Vol. 4: Professional Blueprints',
  desc: '50 complete session structures (Warm-up to Match-play) ready to deploy.'
}, {
  emoji: '📘',
  title: 'Vol. 5: Match-Play & Systems',
  desc: 'The tactical vault. Defensive zone coverage, breakouts, and special teams tricks.'
}, {
  emoji: '📙',
  title: 'Vol. 6: The Elite Coach Business',
  desc: 'Team identity, recruitment/retention strategies, and avoiding coach burnout.'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-4">
            📦 What is inside the ICE HOCKEY READY Bundle?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-5">
          {contents.map((item, i) => <div key={i} className="bg-bg-main rounded-3xl p-6 sm:p-8 border border-border-light flex flex-col items-center text-center shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-6">
              <div className="text-4xl sm:text-5xl mb-4" data-id="element-7">{item.emoji}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-text-main mb-2" data-id="element-8">
                {item.title}
              </h3>
              <p className="text-text-sec text-base" data-id="element-9">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}